

import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
// import './theme.config.css';
import './global.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);